import SimpleBreadcrumbs from "@/modules/pages/components/simple-breadcrumbs/index.vue";
import ReviewsHeaderBlock from "./components/reviews-header-block/index.vue";
import ReviewsSelect from "./components/reviews-select/index.vue";
import ReviewsProductBlock from "@/modules/reviews-page/components/reviews-product-block/index.vue";
import ReviewsPagination from "@/modules/reviews-page/components/reviews-pagination/index.vue";
import ReviewsProfessional from "@/modules/reviews-page/components/reviews-professional/index.vue";
import ReviewsSeoBlock from "@/modules/reviews-page/components/reviews-seo-block/index.vue";
import Loader from "@/components/misc/loader.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { globalLoader } from "@/helpers/variables";

export default {
  name: 'ReviewsPage',
  components: {
    SimpleBreadcrumbs,
    ReviewsHeaderBlock,
    ReviewsSelect,
    ReviewsProductBlock,
    ReviewsPagination,
    ReviewsProfessional,
    ReviewsSeoBlock,
    Loader
  },
  data() {
    return {
      selectedBrand: [],
      selectedProductType: [],
      selectedSkinType: [],
      selectedUsage: [],
      searchQuery: '',
      searchDebounceTimer: null,
      page: 1,
      professionalPage: 1,
      biggestBlockHeight: 0,
      isLoading: false,
    }
  },
  methods: {
    ...mapActions({
      fetchAllProductsFeedbacks: "feedbacks/FETCH_ALL_PRODUCTS_FEEDBACKS",
      fetchAllProductsFeedbacksProfessional: "feedbacks/FETCH_ALL_PRODUCTS_FEEDBACKS_PROFESSIONAL",
      fetchFeedbackContent: "feedbacks/FETCH_FEEDBACKS_PAGE",
      fetchFilters: "feedbacks/FETCH_FILTERS"
    }),
    ...mapMutations({
      changeReviewModalStatus: "popups/CHANGE_REVIEW_FORM_STATUS"
    }),
    findBiggestBlock() {
      if (!this.$refs['review-block']) return
      const blocks = this.$refs['review-block'].map(item => item.$el)
      const biggestBlock = blocks.reduce((biggest, block) => {
        const blockHeight = block.clientHeight
        return blockHeight > biggest.height ? { height: blockHeight} : biggest
      }, { height: 0 })
      this.biggestBlockHeight = biggestBlock.height
      console.log(this.biggestBlockHeight)
    },
    handleResetFilters() {
      this.selectedBrand = []
      this.selectedProductType = []
      this.selectedSkinType = []
      this.selectedUsage = []
      this.searchQuery = ''
      this.page = 1
      this.professionalPage = 1
      this.fetchFeedbacks()
      this.fetchAllProductsFeedbacksProfessional({page: this.professionalPage})
      window.dispatchEvent(new CustomEvent("clear-selects"))
    },
    handleShowReviewModal() {
      this.changeReviewModalStatus(true)
    },
    handleSelectBrand(values) {
      this.selectedBrand = values
      this.page = 1
      this.fetchFeedbacks()
    },
    handleSelectProductType(values) {
      this.selectedProductType = values
      this.page = 1
      this.fetchFeedbacks()
    },
    handleSelectSkinType(values) {
      this.selectedSkinType = values
      this.page = 1
      this.fetchFeedbacks()
    },
    handleSelectUsage(values) {
      this.selectedUsage = values
      this.page = 1
      this.fetchFeedbacks()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchFeedbacks()
    },
    handleChangeProfessionalPage(page) {
      this.professionalPage = page
      this.fetchAllProductsFeedbacksProfessional({page: this.professionalPage})
    },
    handleSearchInput() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1
        this.fetchFeedbacks()
      }, 500)
    },
    async fetchFeedbacks() {
      this.isLoading = true
      this.biggestBlockHeight = 0

      const categoryFilters = [
        ...this.selectedProductType,
        ...this.selectedSkinType,
        ...this.selectedUsage
      ]

      const payload = {}

      if (categoryFilters.length > 0) {
        payload.categories_id = categoryFilters.map(filter => filter.id).join(',')
      }

      payload['per_page'] = window.innerWidth < 768 ? 6 : 8
      payload['with_products'] = 1

      if (this.selectedBrand && this.selectedBrand.length > 0) {
        payload.brand_id = this.selectedBrand.map(brand => brand.id).join(',')
      }

      if (this.searchQuery && this.searchQuery.trim()) {
        payload.search = this.searchQuery.trim()
      }

      await this.fetchAllProductsFeedbacks({...payload, page: this.page})
      this.isLoading = false
      this.findBiggestBlock()
      this.$nextTick(() => {
        this.findBiggestBlock()
      })

      setTimeout(() => {
        this.findBiggestBlock()
      }, 100)
    }
  },
  computed: {
    ...mapGetters({
      content: "feedbacks/content",
      filters: "feedbacks/filters",
      allProductsFeedbacks: "feedbacks/allProductsFeedbacks",
      allProductsFeedbacksProfessional: "feedbacks/allProductsFeedbacksProfessional"
    }),
    getBrands() {
      return this.filters.find(filter => filter.key === 'brands')
    },
    getProductsType() {
      return this.filters.find(filter => filter.slug === 'tip-tovaru')
    },
    getSkinType() {
      return this.filters.find(filter => filter.slug === 'tip-kozhi')
    },
    getUsage() {
      return this.filters.find(filter => filter.slug === 'naznachenie')
    }
  },
  async created() {
    globalLoader(true);
    await Promise.all([
      this.fetchFilters(),
      this.fetchFeedbackContent(),
      this.fetchFeedbacks(),
      await this.fetchAllProductsFeedbacksProfessional({page: this.professionalPage})
    ])
    globalLoader(false);
  }
}
